import { render, staticRenderFns } from "./Quorum.vue?vue&type=template&id=466e5218"
import script from "./Quorum.vue?vue&type=script&lang=js"
export * from "./Quorum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports